var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.MType === 'MSG')?_c('div',{staticClass:"MSG-Message"},[_c('span',[_vm._v(_vm._s(_vm.mmsg))])]):_vm._e(),_vm._v(" "),(_vm.MType === 'ERR')?_c('div',{staticClass:"ERR-Message"},[_c('span',[_vm._v(_vm._s(_vm.mmsg))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-208f9131","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MessageDisplay.vue
// module id = null
// module chunks = 